import React, {useEffect, useRef, useState} from "react";

import {useDispatch, useSelector} from "react-redux";
import makeStyles from '@mui/styles/makeStyles';

import {
    onUpdateScroll,
    updateScroll,
} from "../store/reducers/globals";

import CircularProgress from "@mui/material/CircularProgress";

import config from "../app/config";

import {loadImage} from "../util/loaders";
import {inViewportPartially} from "../util/calcs";
import clsx from "clsx";

import _ from "lodash";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: "#fff",
        backgroundColor: "#fafafa",
        // padding: 4,
        // border: "1px solid #444",
        // position: "relative",
        // border: "1px solid #fff",
        border: "1px solid #444",
        lineHeight: 0,
    },
    rootShadow: {
        boxShadow: theme.shadows[7],
    },
    image: {
        // margin: "auto",
        // position: "absolute",
        // top: 0,
        // left: 0,
        // bottom: 0,
        // right: 0,
        // FIXME: this is how we may zoom this
        // transform: "scale(2)",
        userSelect: "none",
    },
    progress: {
        // textAlign: "center",
        // position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // margin: "auto",
        // position: "absolute",
        // top: 0,
        // left: 0,
        // bottom: 0,
        // right: 0,
    },
}));

function Image(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const imageElement = useRef(null);
    const rootElement = useRef(null);

    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);

    // visible
    // loading
    //

    const onScroll = useSelector(onUpdateScroll);

    useEffect(() => {
        if (props.lazy) {
            // only if not loaded and not loading !
            if (!visible) {
                // console.log("look for it", inViewportPartially(rootElement.current));
                if (inViewportPartially(rootElement.current)) {
                    setVisible(true);
                }
            }
            // otherwise all good - image is there already
        } else {
            // simply set visible if not visible at the moment
            if (!visible) {
                setVisible(true);
            }
        }
    }, [onScroll, props.lazy]);

    useEffect(() => {
        // we need to load this now
        if (!loading && visible) {
            setLoading(true);
            // console.log("loading ...");
            loadImage(props.src)
                .then(result => {
                    imageElement.current.setAttribute("src", result);
                    setLoaded(true);
                    setLoading(false);
                    dispatch(updateScroll());
                })
                .catch(ex => {
                    // TODO: show simple error / image / info ?
                });
        }
    }, [visible]);

    /*
    useEffect(() => {
        loadImage(props.src)
            .then(result => {
                imageElement.current.setAttribute("src", result);
            })
            .catch(ex => {
                // TODO: show simple error / image / info ?
            });
    }, [props.src]);
    */

    let imageWidth = config.modules.viewer.image.defaultWidth;
    let imageHeight = config.modules.viewer.image.defaultHeight;

    if (props.size) {
        imageWidth = props.size;
        // imageHeight = props.size.h;
        imageHeight = props.size * config.modules.viewer.image.defaultRatio;
    }

    if (loaded) {
        // we need to get real image w/h
        //
        // imageWidth = "auto";
        // imageHeight = "auto";
        // console.log("img", imageElement.current.clientWidth, imageElement.current.clientHeight);
        // imageWidth = imageElement.current.clientWidth;
        // imageHeight = imageElement.current.clientHeight;
    }

    return (
        <div className={clsx([classes.root, props.shadowed && classes.rootShadow])} style={{
            // width: imageWidth,
            // height: imageHeight,
            // maxWidth: imageWidth,
            // maxHeight: imageHeight,
            width: "fit-content",
        }} ref={rootElement}>
            {!loaded && <div className={classes.progress} style={{
                // display: !loaded ? "block" : "none",
                width: imageWidth,
                height: imageHeight,
                // width: config.modules.viewer.image.loadingIndicatorSize,
                // height: config.modules.viewer.image.loadingIndicatorSize,
            }}>
                {/*{visible && <CircularProgress size={config.modules.viewer.image.loadingIndicatorSize}/>}*/}
                {/*<CircularProgress size={config.modules.viewer.image.loadingIndicatorSize}/>*/}
                {visible && <img width={imageWidth} src={"/image/loading.gif"} alt={""}/>}
            </div>}
            <img className={classes.image} style={{
                display: loaded ? "block" : "none",
                width: imageWidth,
                // height: imageHeight,
                // minWidth: _.min([imageWidth, imageHeight]),
                // minHeight: _.min([imageWidth, imageHeight]),
                maxWidth: imageWidth,
                maxHeight: imageHeight,
            }} ref={imageElement} alt={""}/>
        </div>
    );
}

export default Image;
